import { ICommand } from 'core-ts-types';
import { PlatformUtility } from 'utility-ts-platform';
import { ConditionalSwitch } from 'utility-ts-strategy';
import { StudyGroupModalService } from '../../modals/study_groups_modal_service';
import { ICourseSection } from '../../study_group_interfaces';

interface IStudyBuddyText {
  is_buddy: boolean;
  study_buddy_count: string;
}

export class StudyGroupSectionTileController {
  private section: ICourseSection;
  private studyBuddiesCountText: string;
  private sectionLabel: string;
  private isMobile: boolean;
  private detailsState: string;
  private detailsStateParams: { sectionId: number };
  constructor(private $state: ng.ui.IStateService, private appConfigModel: any) {}

  $onInit() {
    this.sectionLabel = this.appConfigModel.getConfigProperty('section_label') || 'Section';
    this.determineStudyBuddiesCountText();
    this.isMobile = PlatformUtility.isMobile();
    this.detailsState = `my.studyGroupMembers`;
    this.detailsStateParams = { sectionId: this.section.id };
  }

  $onChanges() {
    this.determineStudyBuddiesCountText();
  }

  determineStudyBuddiesCountText() {
    switch (this.section.study_buddy_count) {
      case 0: {
        this.studyBuddiesCountText = 'Be the first to join';
        break;
      }
      case 1: {
        this.studyBuddiesCountText = this.section.is_buddy ? 'Waiting for buddies' : '1 buddy';
        break;
      }
      case 2: {
        this.studyBuddiesCountText = this.section.is_buddy ? '1 other buddy' : '2 buddies';
        break;
      }
      default: {
        this.studyBuddiesCountText = this.section.is_buddy
          ? `${this.section.study_buddy_count - 1} buddies`
          : `${this.section.study_buddy_count} buddies`;
      }
    }
  }

  goToDetails() {
    this.$state.go(this.detailsState, this.detailsStateParams);
  }
}

export class StudyGroupSectionTileComponent implements angular.IComponentOptions {
  public templateUrl: string =
    'capability-ng-study-groups/src/components/study_group_section_tile/study_group_section_tile.html';
  public controller: any = StudyGroupSectionTileController;
  public controllerAs: string = '$ctrl';
  public bindings: any = {
    section: '<'
  };
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-study-groups/src/components/study_group_section_tile/study_group_section_tile_component.ts